import { SignUp } from '@clerk/clerk-react'

export default function SignUpPage() {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: 'var(--bg-default)',
    }}>
      <SignUp 
        routing="path" 
        path="/sign-up"
        signInUrl="/login"
        appearance={{
          variables: {
            colorPrimary: '#408A71', // mint-green accent
            colorBackground: '#091413',
            colorText: '#ffffff',
            colorInputBackground: '#1a2e2a',
            colorInputText: '#ffffff',
            colorDanger: '#f87171',
            colorSuccess: '#4ade80'
          },
          elements: {
            card: {
              boxShadow: 'var(--shadow-glow)',
              border: '1px solid var(--border)',
            }
          }
        }}
      />
    </div>
  )
}
